module.exports = __webpack_public_path__ + "img/violet_082.f9fd9aff.png";